import { cilHome, cilCreditCard, cilBank, cilCart, cilMemory, cilSpeedometer, cilClipboard, cilFingerprint, cilUser, cilSpreadsheet, cilSettings, cilSitemap, cilPeople, cilAccountLogout } from '@coreui/icons'

export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/',
        icon: cilHome
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Module'],
        permission: ['token_view', 'tr_view', 'tr_profile_view', 'card_view', 'issuer_view', 'issuer_profile_view']
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Token Management',
        icon: cilFingerprint,
        permission: 'token_view',
        items: [
          {
            name: 'Token List',
            to: '/tokens',
            icon: cilFingerprint
          },
          {
            name: 'Token Transactions',
            to: '/tokens/transaction',
            icon: cilSpreadsheet,
            permission: 'token_view_trans'
          },
          {
            name: 'Token Events',
            to: '/tokens/event',
            icon: cilSpreadsheet,
            permission: 'token_view_event'
          },
          {
            name: 'DeToken',
            to: '/de-token',
            icon: cilFingerprint,
            permission: 'token_detokenize'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Card Management',
        route: '/cards',
        icon: cilCreditCard,
        permission: 'card_view',
        items: [
          {
            name: 'Card List',
            to: '/cards',
            icon: cilCreditCard
          },
          {
            name: 'Card Events',
            to: '/cards/event',
            icon: cilSpreadsheet,
            permission: 'card_view_event'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Issuer Management',
        icon: cilBank,
        route: '/issuers',
        permission: ['issuer_view', 'bin_view', 'issuer_batch_view', 'issuer_profile_view'],
        items: [
          {
            name: 'Issuer List',
            to: '/issuers',
            icon: cilBank,
            permission: 'issuer_view'
          },
          {
            name: 'Issuer Detail',
            to: '/issuer/profile',
            icon: cilBank,
            permission: 'issuer_profile_view'
          },
          {
            name: 'BIN Ranges',
            to: '/bins',
            icon: cilSpreadsheet,
            permission: 'bin_view'
          },
          {
            name: 'Batch Silent Update',
            to: '/batch-silent-update',
            icon: cilSpreadsheet,
            permission: 'issuer_batch_view'
          }
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Token Requestor Management',
        to: '/merchants',
        permission: 'tr_view',
        icon: cilCart
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Token Requestor Detail',
        to: '/merchant/profile',
        permission: 'tr_profile_view',
        icon: cilCart
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Export Data',
        to: '/data',
        permission: 'data_export',
        icon: cilSpreadsheet
      },
      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Test'],
        permission: ['test_view', 'test_update', 'test_tool']
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'API Integration',
        icon: cilClipboard,
        permission: ['test_view', 'test_update'],
        items: [
          {
            name: 'Submit API Test Result',
            to: '/test/submit',
            icon: cilClipboard,
            permission: 'test_update'
          },
          {
            name: 'API Test Results',
            to: '/test',
            icon: cilClipboard,
            permission: 'test_view'
          }
        ]
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Test Tools',
        icon: cilSpeedometer,
        permission: 'test_tool',
        items: [
          {
            name: 'Token Provision',
            to: '/test-tool/token-provision',
            icon: cilSpeedometer,
            permission: 'test_tool'
          },
          {
            name: 'Data Encryption',
            to: '/test-tool/data-encrypt',
            icon: cilSpeedometer,
            permission: 'test_tool'
          }
        ]
      },
      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['System'],
        permission: ['system_view', 'risk_view', 'host_view', 'access_view', 'system_infra', 'audit_view', 'task_history_view', 'task_history_view_all']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Settings',
        to: '/settings',
        permission: 'system_view',
        icon: cilSettings
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Risk Management',
        to: '/risk-management',
        permission: 'risk_view',
        icon: cilSettings
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Host Management',
        to: '/hosts',
        icon: cilMemory,
        permission: 'host_view'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Access Control',
        route: '/users',
        icon: cilPeople,
        permission: 'access_view',
        items: [
          {
            name: 'Users',
            to: '/users',
            icon: cilPeople
          },
          {
            name: 'Roles',
            to: '/roles',
            icon: cilSitemap
          }
        ]
      },
      {
        _name: 'CSidebarNavItem',
        name: 'System Infrastructure',
        to: '/system-infra',
        permission: 'system_infra',
        icon: cilSettings
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Logs',
        icon: cilSpreadsheet,
        permission: ['audit_view', 'task_history_view', 'task_history_view_all'],
        items: [
          {
            name: 'Audit Logs',
            to: '/audit-logs',
            permission: 'audit_view',
            icon: cilSpreadsheet
          },
          {
            name: 'Task History',
            to: '/task-history',
            permission: ['task_history_view', 'task_history_view_all'],
            icon: cilSpreadsheet
          }
        ]
      },
      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['My Profile']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Account Detail',
        to: '/me',
        icon: cilUser
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logout',
        to: '/logout',
        icon: cilAccountLogout
      }
    ]
  }
]
